module.exports = __webpack_public_path__ + "img/f_c_sc_5.1e5da436.png";